import React, { lazy, Suspense } from 'react';
import { getContext } from '@fiverr-private/fiverr_context';
import { env } from '@fiverr-private/futile';

const LazyLogoMakerBriefCarousel = lazy(() =>
    import(
        /* webpackChunkName: 'LogoMakerBriefCarousel' */ '../../MarketplaceBrief'
    )
);

const initializeLogoMakerBanner = ({
    page,
    listingsType,
    query,
    source,
    sourcePage,
    sourceComponent,
    bannerRow,
}) => {
    const { pageCtxId, userId, userGuid, isTouch } = getContext();

    const lmBannerContext = {
        page,
        listingsType,
        position: bannerRow,
        ...(query && { query }),
        userGuid,
        pageCtxId,
        refCtxId: source,
        userId,
        sourcePage,
        sourceComponent,
    };

    return env.browser ? (
        <Suspense fallback={null}>
            <LazyLogoMakerBriefCarousel
                isTouch={isTouch}
                context={lmBannerContext}
                source="marketplace"
                target="_blank"
            />
        </Suspense>
    ) : null;
};

export default initializeLogoMakerBanner;
